import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

import { GetCandidateStats } from "../apiconstants/constants";
import LoadingSpinner from "../helpers/loadingspinner";
import { useCountry } from "../contexts/countrycodecontext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const OverallRecruiterBarGraph = ({ dateFilter }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { selectedCountry } = useCountry(); 
  const token = localStorage.getItem("jwtToken");
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const roleID = localStorage.getItem("roleID");
  const Guid = roleID == 3 ? employerGuid : guid;
 console.log("graph date filter", dateFilter);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const res = await axios.get(GetCandidateStats.APIURL, {
          params: {
            guid: Guid,
            DateFilter: dateFilter,
            CountryID: selectedCountry,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(res.data || []);
      } catch (err) {
        console.error("Error fetching recruiter stats", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [Guid, dateFilter, selectedCountry, token]);

  // ✅ Aggregate totals
  const totals = data.reduce(
    (acc, user) => {
      acc.overall += user.overallCount || 0;
      acc.new += user.new || 0;
      acc.submitted += user.jobSubmission || 0;
      acc.shortlisted += user.shortlisted || 0;
      acc.offers += user.offersReleased || 0;
      acc.interviews += user.interviewsScheduled || 0;
      acc.rejected += user.rejected || 0;
      acc.onHold += user.onHold || 0;
      return acc;
    },
    {
      overall: 0,
      new: 0,
      submitted: 0,
      shortlisted: 0,
      offers: 0,
      interviews: 0,
      rejected: 0,
      onHold: 0,
    }
  );

 const chartData = {
  labels: ["Count"],
  datasets: [
    {
      label: "Overall",
      data: [totals.overall],
      backgroundColor: "#00a7ac",
      borderRadius: 6,
    },
    {
      label: "New",
      data: [totals.new],
      backgroundColor: "#6c757d",
      borderRadius: 6,
    },
    {
      label: "Job Submissions",
      data: [totals.submitted],
      backgroundColor: "#007bff",
      borderRadius: 6,
    },
    {
      label: " In-progress",
      data: [totals.shortlisted],
      backgroundColor: "#ffc107",
      borderRadius: 6,
    },
    {
      label: "Offers Released",
      data: [totals.offers],
      backgroundColor: "#28a745",
      borderRadius: 6,
    },
    {
      label: "Interviews",
      data: [totals.interviews],
      backgroundColor: "#960cb2ff",
      borderRadius: 6,
    },
    {
      label: "Rejected",
      data: [totals.rejected],
      backgroundColor: "#dc3545",
      borderRadius: 6,
    },
    {
      label: "On Hold",
      data: [totals.onHold],
      backgroundColor: "#343a40",
      borderRadius: 6,
    },
  ],
};


 const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,          // ✅ SHOW legend
      position: "bottom",     // ✅ BELOW chart
      labels: {
        boxWidth: 14,
        boxHeight: 14,
        padding: 15,
        font: {
          size: 12,
        },
      },
    },
    title: {
      display: true,
  
      color: "#00a7ac",
      font: { size: 16 },
    },
    datalabels: {
      anchor: "end",
      align: "top",
      color: "#000",
      font: {
        size: 12,
        weight: "bold",
      },
      formatter: (value) => value,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        precision: 0,
      },
    },
  },
};


  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
         
        }}
      >
        <h5 style={{ color: "#00a7ac", margin: 0 }}>
          Recruiter Statistics
        </h5>

        <div style={{ width: 200 }}>
          
        </div>
      </div>

      {loading ? (
        <center>
          <LoadingSpinner />
        </center>
      ) : (
        <Bar data={chartData} options={chartOptions} />
      )}
    </div>
  );
};

export default OverallRecruiterBarGraph;
